/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { AppTable, DeleteConfirmDialog } from "components/molecules";
import { TableHelper } from "helpers";
import { usePaginationRequest } from "hooks/useRequest";
import { IDownloadExcelRequest, IPaginationRequest } from "model";
import { IPaginateApiResponse } from "model/Common/IPaginateApiResponse";
import { IUser } from "model/User/IUser";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { DownloadActions, UserActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import UserApiService from "services/UserApiService";
import { CURRENT_PAGE_SIZE, EXPORT_FILE_NAME, FIRST_PAGE } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";

const UserConfiguration = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const action = useAppSelector((state) => state.UserReducer.action);
  const [open, setOpen] = useState(false);
  const [itemSelected, setItemSelected] = useState<IUser>();
  const [refresh, setRefresh] = useState(false);
  const [request, setRequest] = useState<IPaginationRequest>({
    pageNumber: FIRST_PAGE,
    pageSize: CURRENT_PAGE_SIZE,
    isActive: true,
  });
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [currentActive, setCurrentActive] = useState<boolean | any>(true);
  const [currentWarehouse, setCurrentWarehouse] = useState<boolean | any>("A");

  const downloading = useAppSelector(
    (state) => state.AppConfigReducer.downloading
  );
  const { loading, result } = usePaginationRequest<IPaginationRequest, IUser[]>(
    request,
    UserApiService.getAllUsers,
    [],
    {
      refresh: refresh,
    },
    () => {
      setRefresh(false);
    }
  );

  const onPressEdit = (item: any) => {
    history.push({
      pathname: `${location.pathname}/edit/${item.id}`,
      state: {
        item: JSON.stringify(item),
      },
    });
  };

  const _handleTypeChange = (callback: { warehouse?: any; isActive?: any }) => {
    setCurrentActive(callback.isActive);
    setCurrentWarehouse(callback.warehouse);
    const params = {
      ...request,
      pageNumber: FIRST_PAGE,
      isActive: callback.isActive,
    };

    if (callback.isActive === "A") {
      delete params["isActive"];
    }
    setRequest(params);
  };

  const onPressDelete = (item: any) => {
    setItemSelected(item);
    setOpen(true);
  };
  const handleFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteUser = () => {
    _deleteUser(itemSelected?.id!);
  };
  const deleteUserSuccessfully = action.includes(
    UserActions.deleteUser.successName
  );

  const _deleteUser = (id: string) => {
    dispatch(
      UserActions.deleteUser.request({
        id: id,
      })
    );
  };
  const _clearAction = () => {
    dispatch(UserActions.clearAction.request());
  };

  const handlePageChange = (pageNumber: number) => {
    setRequest({ ...request, pageNumber: pageNumber });
  };
  const handleSearchTextChange = (searchText: string) => {
    setRequest({ ...request, pageNumber: FIRST_PAGE, searchText: searchText });
  };

  const _handlePageSizeChange = (pageSize: number) => {
    setRequest({ ...request, pageSize: pageSize });
  };

  const _downloadUserMasterData = () => {
    const params: IDownloadExcelRequest = {
      ...request,

      pageSize: (result as IPaginateApiResponse<IUser[]>).totalRecords,
      pageNumber: FIRST_PAGE,
      fileName: EXPORT_FILE_NAME.userMasterData,
      warehouseId: "",
    };
    dispatch(DownloadActions.downloadUserMasterData.request(params));
  };

  useEffect(() => {
    if (deleteUserSuccessfully) {
      setRefresh(true);
      setOpen(false);
      _clearAction();
    }
  }, [action]);

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "userName",
      headerName: I18nTranslator(translations.masterData.userName),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "firstName",
      headerName: I18nTranslator(translations.masterData.firsName),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "lastName",
      headerName: I18nTranslator(translations.masterData.lastName),
      size: "small",
      align: "left",
    }),

    TableHelper.createCell({
      field: "email",
      headerName: I18nTranslator(translations.masterData.email),
      size: "full",
      align: "left",
    }),
    TableHelper.createCell({
      field: "roleName",
      headerName: I18nTranslator(translations.masterData.role),
      size: "full",
      align: "left",
    }),
    TableHelper.createCell({
      field: "warehouseName",
      headerName: I18nTranslator(translations.masterData.warehouseName),
      size: "full",
      align: "left",
    }),
    TableHelper.renderActivationCell("isActive"),
  ];

  return (
    <Fragment>
      <AppTable
        title={I18nTranslator(translations.masterData.userConfiguration)}
        loading={loading}
        data={result}
        columns={COLUMNS}
        onAddNewClick={() => history.push(`${location.pathname}/new`)}
        onSearch={handleSearchTextChange}
        searchPlaceholder={I18nTranslator(translations.placeholder.searchUser)}
        onChangePage={handlePageChange}
        onRowPressEdit={(row) => onPressEdit(row)}
        onRowPressDelete={(row) => onPressDelete(row)}
        hideImport
        actionColumnProps={{ hideImport: true }}
        onPageSizeChange={_handlePageSizeChange}
        onDownloadClick={_downloadUserMasterData}
        isDownloading={downloading}
        onPressFilter={handleFilterClick}
      />
      <DeleteConfirmDialog
        open={open}
        value={itemSelected?.userName}
        handleClose={handleClose}
        handleDelete={handleDeleteUser}
        isDeleting={action.includes(UserActions.deleteUser.requestName)}
      />
    </Fragment>
  );
};

export default UserConfiguration;
